// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2ABMm","itemTitle":"ClientEmergencyInfo_itemTitle__3bfsI","itemText":"ClientEmergencyInfo_itemText__uXCDI"};